<template>
  <div>
    <p class="title">{{ revType }} Reviews</p>

    <div v-if="initialLoading" class="d-flex justify-content-center mt-3">
      <div><div class="spinner-border position-absolute spinner-class"></div></div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
    </div>

    <div v-if="!initialLoading">
      <div class="mobile-top" v-if="reviews.data.length != 0">
        <div :style="{ display: 'flex', alignItems: 'center' }">
          <div class="detail-container" v-if="!loading">
            <div>
              <div>
                <div style="display: flex; justify-content: center">
                  <div class="star-container" :style="{ background: getPrimaryColor() }">
                    <font-awesome-icon size="2x" style="transform: scale(0.7); width: 24px; height: 24px; color: white" :icon="['fas', 'star']" />
                  </div>
                  <p class="review-text" :style="{ 'margin-bottom': '0px' }">{{ overall_rating ? overall_rating.toFixed(2) : "0" }}</p>
                </div>
              </div>
              <p class="review-subtext" :style="{ 'margin-bottom': '0px' }">Overall Rating</p>
            </div>
            <a-divider type="vertical" style="height: 50px; margin: 0px 40px" />
            <div>
              <div>
                <div style="display: flex; justify-content: center">
                  <p class="review-text" style="margin-left: 0px; margin-bottom: 0px">{{ total_reviews ? total_reviews : "0" }}</p>
                </div>
                <p class="review-subtext" :style="{ 'margin-bottom': '0px' }">Reviews</p>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-container-mobile" v-if="!loading">
          <div style="flex: 1">
            <div style="display: flex; justify-content: center">
              <div class="star-container" :style="{ background: getPrimaryColor() }">
                <font-awesome-icon size="2x" style="transform: scale(0.7); width: 24px; height: 24px; color: white" :icon="['fas', 'star']" />
              </div>
              <p class="review-text mb-0">{{ overall_rating ? overall_rating.toFixed(1) : "0" }}</p>
            </div>
            <p class="review-subtext mb-0">Overall Rating</p>
          </div>
          <a-divider type="vertical" style="height: 78px" />
          <div style="flex: 1">
            <div style="display: flex; justify-content: center">
              <p class="review-text mb-0" style="margin-left: 0px">{{ total_reviews ? total_reviews : "0" }}</p>
            </div>
            <p class="review-subtext mb-0">Reviews</p>
          </div>
        </div>
      </div>
      <div v-if="loading" class="d-flex justify-content-center mt-3">
        <div><div class="spinner-border position-absolute spinner-class"></div></div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px', marginBottom: '40px' }">Loading...</div>
      </div>
      <!-- <div
        v-if="reviews.data.length === 0 && !loading"
        style="text-align:center; padding: 20px;"
      >
        No Reviews
      </div> -->
      <div class="page-container">
        <template v-if="reviews.data.length && !loading">
          <template v-if="['MyCircles', 'Telemedicine'].includes(revType)">
            <IndividualReviewCard v-for="review in reviews.data" :reviewData="review" :key="review" />
          </template>
          <template v-else>
            <ReviewCardCore v-for="review in reviews.data" :reviewData="review" :key="review.id" :ownerView="IsOwnerView" :getReviewsFromCore="getReviewsFromCore" />
          </template>
        </template>

        <div v-if="reviews && reviews.data && reviews.data.length && !loading" class="d-flex justify-content-center">
          <!-- <a-pagination
            v-model="currentPage"
            class="dovemed-custom-pagination"
            :total="
              reviews.paginator.total_count
                ? parseInt(reviews.paginator.total_count)
                : 0
            "
            show-less-items
            :pageSize="10"
            @change="fetchIndividualReviews"
          /> -->

          <a-button @click="goToReviewsTab()" :style="{ background: getPrimary50Color() }" class="mx-auto dovemed-button w-100" v-if="total_reviews > 3">
            <span class="fw700 font14" :style="{ color: getPrimaryColor() }"> View {{ total_reviews - 3 }} more {{ revType }} Reviews </span>
            <font-awesome-icon
              size="2x"
              class="mr-2"
              :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', marginBottom: '-6px', color: getPrimaryColor() }"
              :icon="['fa', 'arrow-right']"
            />
          </a-button>
        </div>
      </div>
    </div>

    <div v-if="!initialLoading && !loading && !reviews.data.length">
      <div v-if="IsOwnerView" class="dailog1">You have no reviews yet</div>
      <div v-else>
        <div class="dailogbox">
          <div class="dailog-wrapper">
            <span class="dailog">This {{ user_role }} has no {{ revType }} reviews yet.</span>
            <template v-if="canReview(user_role)">
              <span class="sub-dailog">Be the first to review this {{ user_role }}.</span>
              <button class="get-started-btn" :style="{ background: getPrimaryColor() }" @click="handleReviewClick">Review</button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <RecommendDoctor ref="doctorRev" :fetchReviews="getAllReviews" />
    <RecommendOthers ref="otherRev" :fetchReviews="getAllReviews" />
  </div>
</template>

<script>
import IndividualReviewCard from "../../../home/reviews/ReviewTabCard.vue"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import RecommendDoctor from "../../../Modals/RecommendDoctor.vue"
import RecommendOthers from "../../../Modals/RecommendOthers.vue"
import { mapGetters } from "vuex"
import ReviewCardCore from "../../../home/reviews/ReviewCardCore.vue"

const ReviewsRepository = RepositoryFactory.get("reviews")

export default {
  name: "DoctorAboutReview",
  props: {
    refId: Number,
    IsOwnerView: Boolean,
    revType: { default: "", type: String },
    avgRating: Number,
  },
  components: {
    IndividualReviewCard,
    RecommendDoctor,
    RecommendOthers,
    ReviewCardCore,
  },

  data() {
    return {
      user_role: "",
      initialLoading: false,
      reviews: { data: [] },
      // reviewee_id: null,
      loading: false,
      currentPage: 1,
      api_role: undefined,
      overall_rating: null,
      total_reviews: 0,
      count: undefined,
      sortKey: "Newest",
      sortList: {
        Newest: "Newest First",
        Oldest: "Oldest First",
        Rating: "Highest Rated First",
        Nearest: "Nearest To You",
      },
    }
  },

  computed: {
    onlyCore() {
      let role = null
      if (this.IsOwnerView) {
        role = this.authUser.user.role
      } else {
        role = this.viewUser.role
      }
      switch (role) {
        case "doctor":
        case "physician":
        case "ohcp":
        case "hcp":
        case "ahcp":
        case "other":
          return false
        default:
          return true
      }
    },
    ...mapGetters({ toggleReview: "User/toggleReview" }),
  },

  created() {
    console.warn("DoctorAboutReview.vue created")
    if (!this.IsOwnerView) {
      this.user_role =
        this.viewUser.role === "patient" ||
        this.viewUser.role === "advocate" ||
        this.viewUser.role === "caregiver" ||
        this.viewUser.role === "doctor" ||
        this.viewUser.role === "hospital" ||
        this.viewUser.role === "nfp" ||
        this.viewUser.role === "hcp" ||
        this.viewUser.role === "business" ||
        this.viewUser.role === "clinic"
          ? this.viewUser.role.replace(/\b(\w)/g, s => s.toUpperCase())
          : this.viewUser.role === "clinic_administrator"
          ? "Clinic"
          : this.viewUser.role === "nfp_administrator"
          ? "NFP"
          : this.viewUser.role === "business_administrator"
          ? "Business"
          : this.viewUser.role === "hospital_administrator"
          ? "Hospital"
          : "Entity"

      switch (this.viewUser.role) {
        case "hospital":
          this.api_role = "hospital_administrator"
          break
        case "clinic":
          this.api_role = "clinic_administrator"
          break
        case "nfp":
          this.api_role = "nfp_administrator"
          break
        case "doctor":
        case "physician":
          this.api_role = "doctor"
          break
        case "hcp":
        case "ohcp":
        case "ahcp":
        case "other":
          this.api_role = "hcp"
          break
        default:
          this.api_role = this.viewUser.role
          break
      }
    } else {
      this.api_role = this.authUser.user.role
    }
    // this.reviewee_id = this.refId
  },
  mounted() {
    this.getAllReviews()
    this.overall_rating = this.avgRating
  },
  watch: {
    toggleReview: {
      handler(v) {
        this.getAllReviews()
      },
      // immediate: true,
    },
  },
  methods: {
    goToReviewsTab() {
      const typeOfProfileURL = `${this.$route.path.includes("view") ? `view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}` : `${this.authUser.user.role}`}`
      switch (this.revType) {
        case "Telemedicine":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${typeOfProfileURL}/receivedreviews/online` })
          break
        case "In Person Visit":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${typeOfProfileURL}/receivedreviews/inperson` })
          break
        case "MyCircles":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${typeOfProfileURL}/receivedreviews/mycircles` })
          break
        default:
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${typeOfProfileURL}/receivedreviews/all` })
      }
    },
    getAllReviews() {
      if (["MyCircles", "Telemedicine"].includes(this.revType)) {
        this.fetchIndividualReviews()
      } else {
        this.getReviewsFromCore()
      }
    },
    handleReviewClick() {
      console.log("rev btn clickd")
      // console.log("user_role:", this.user_role)
      // console.log("view user:", this.viewUser)
      switch (this.viewUser.role) {
        case "patient":
        case "caregiver":
        case "advocate":
        case "nfp":
        case "nfp_administrator":
        case "business":
        case "business_administrator":
          this.$notification.error({ message: "Denied", description: `${this.authUser.user.role} cannot review a ${this.viewUser.role}` })
          break
        case "doctor":
        case "physician":
        case "ahp":
        case "ahcp":
        case "hcp":
        case "ohcp":
        case "amp":
        case "app":
        case "other":
          if (!["patient", "caregiver", "advocate"].includes(this.authUser.user.role)) {
            this.$notification.error({ message: "Denied", description: `${this.authUser.user.role} cannot review a ${this.viewUser.role}` })
            return
          }
          this.$refs.doctorRev.show({ ...this.viewUser, inPersonReview: this.viewUser.in_person_visit, onlineReview: this.viewUser.online_tele_medicine, myCirclesReview: this.viewUser.my_circle })
          break
        case "clinic":
        case "clinic_administrator":
        case "hospital":
        case "hospital_administrator":
          if (!["patient", "caregiver", "advocate"].includes(this.authUser.user.role)) {
            this.$notification.error({ message: "Denied", description: `${this.authUser.user.role} cannot review a ${this.viewUser.role}` })
            return
          }
          this.$refs.otherRev.show({ ...this.viewUser })
          break
        default:
          this.$notification.error({ message: "Denied", description: `${this.authUser.user.role} cannot review a ${this.viewUser.role}` })
          break
      }
    },
    sortReviews(sort) {
      this.sortKey = sort
      this.getAllReviews()
    },
    goToNext() {
      this.currentPage += 1
      this.getAllReviews(true)
    },
    fetchIndividualReviews(append = false) {
      this.loading = true

      ReviewsRepository.getIndividualReviews(
        this.currentCircle.id,
        this.currentPage,
        append ? 10 : 3,
        // this.reviewee_id,
        this.refId,
        this.revType === "Telemedicine" ? "Online" : "MyCircles",
        this.sortKey,
        this.api_role
      )
        .then(res => {
          if (res.data.message === "found") {
            if (append) {
              this.reviews.data.push(...res.data.data.data)
            } else {
              this.reviews = res.data.data
            }
            this.total_reviews = res.data.message === "found" ? res.data.data.paginator.total_count : 0
            // document.body.scrollTop = 0
            // this.count = res.data.message === "found" ? res.data.data.paginator.total_count : 0
          } else {
            this.reviews = res.data
          }
          console.log("DoctorAboutReview -> reviews:", this.reviews)
          this.setData()
          this.loading = false
          this.initialLoading = false
        })
        .catch(err => {
          this.loading = false
          this.initialLoading = false
          // console.log(err)
        })
    },

    getReviewsFromCore() {
      const role = this.$route.path.includes("view") ? this.viewUser.role : this.authUser.user.role
      const ext_id = this.$route.path.includes("view") ? this.viewUser.ext_ref_id || this.viewUser.id : this.authUser.user.ext_ref_id || this.authUser.user.id
      const headers = { Authorization: `Basic ${btoa("dovemed:dovemed-rules")}`, dtoken: this.authUser.user.dovemed_csrf_token || this.authUser.user.dovemed_session_token }
      this.loading = true
      this.$http
        .get(`${process.env.SSO_BASE_URL}/api/v2/review/${this.getCoreReviewApiRole(role)}/${ext_id}/review/?page=1&page_size=3&ordering=-published`, { headers })
        // .get(`${process.env.SSO_BASE_URL}/api/v2/${this.getCoreReviewApiRole(role)}/${ext_id}/review/?page=1&page_size=3&ordering=-published`, { headers })
        .then(res => {
          this.loading = false
          this.reviews.data = res.data.results
          this.total_reviews = res.data.count || 0
        })
        .catch(e => {
          this.loading = false
          console.log("error: ", e)
          console.log(e.message)
          UserRepository.recordLogout()
          this.$store.dispatch("Auth/logout").then(() => {
            location.reload()
          })
        })
    },

    setData() {
      console.log("setData()")
      if (this.revType === "In Person Visit") {
        return
      }
      if (this.reviews.data.length != 0) {
        // this.overall_rating = this.reviews.data[0].overall_rating || 0
        this.total_reviews = this.reviews.paginator.total_count || 0
      }
    },
  },
}
</script>

<style lang="scss">
.dovemed-custom-pagination .ant-pagination-item-active {
  background: #2a71d4;
}

.dovemed-custom-pagination .ant-pagination-item-active a {
  color: #ffffff !important;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
}

.dovemed-custom-pagination .ant-pagination-item-active a:hover {
  color: #ffffff !important;
}
</style>

<style lang="scss" scoped>
.get-started-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 159.5px;
  height: 41px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff;
  border: none;
}

.sub-dailog {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #33415f;
}

.dailog {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}

.dailog1 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 16px;
  height: 56px;
  background: #f1f5f9;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #94a3b8;
  width: 100%;
}

.title {
  font-size: 32px;
  font-weight: bold;
  color: #0f1734;
  line-height: 42px;
}

.mobile-top {
  @media only screen and (max-width: 767px) {
    -webkit-box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
    box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
    padding-bottom: 16px;
    border-radius: 0px;
  }
}

.back-button {
  font-family: "Lato";
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 27px;
  text-align: start;
}

.profile-img2 {
  width: 70px;
  height: 70px;
  border-radius: 50%;
}

.text-name {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  margin-left: 16px;
  margin-bottom: 4px;
  text-transform: capitalize;
}

.radio-group {
  @media only screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}

.text-day {
  font-weight: 400;
  font-size: 12px;
  color: #94a3b8;
  margin-left: 16px;
  margin-bottom: 0px;
}

.page-container {
  @media only screen and (max-width: 767px) {
    // padding: 16px;
    // padding-top: 0px;
  }
}

.page-info {
  margin-top: 48px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 767px) {
    margin-top: 24px;
    margin-bottom: 16px;
  }
}

.result-length {
  font-weight: 700;
  font-size: 20px;
  color: #0f1734;
}

.detail-container {
  display: flex;
  background-color: #f1f5f9;
  height: 110px;
  align-items: center;
  padding: 0px 40px;
  padding-top: 20px;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 20px;
  @media only screen and (max-width: 900px) {
    display: none;
  }
}

.detail-container-mobile {
  display: flex;
  background-color: #f1f5f9;
  // height: 110px;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  padding: 16px;
  @media only screen and (min-width: 901px) {
    display: none;
  }
}

.review-text {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  margin-left: 8px;
}

.star-container {
  width: 24px;
  height: 24px;
  border-radius: 2px;
}

.review-subtext {
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #94a3b8;
  // margin-top: 2px;
  text-align: center;
  white-space: nowrap;
}

.checkbox-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
  margin-right: 48px;
}

.sort-text {
  font-weight: 400;
  font-size: 14px;
  color: #0f1734;
  margin-bottom: 0px;
  cursor: pointer;
  white-space: nowrap;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/view/DoctorAboutReview.vue